export default "__VITE_ASSET__f38d2c9d__"